import moment from "moment";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { statusColors } from "../useDeparture";

const statusLabel = {
  TRANSP: "TRANSPORT",
  TO_PREP: "TO PREPARE",
  INCIDENT: "INCIDENT",
  READY: "READY",
  RECUP: "RETRIEVAL",
  DELIVERY: "DELIVERY",
  DELIVERED: "DELIVERED",
};

const DepartureInfos = () => {
  const { t } = useTranslation("common");
  const { delivery } = useSelector((state) => state.deliveryReducer);

  const order = delivery?.attributes?.commande?.data;
  const reseller = order?.attributes?.reseller?.data;
  const packings = order?.attributes?.packings?.data;
  const approv = packings?.[0]?.attributes?.approvisionnement?.data;
  const depot = approv?.attributes?.realEntrepot?.data;
  const storekeeper = delivery?.attributes?.storekeeper?.data;
  const depotAddress = depot?.attributes?.address?.data;
  const deliveryAddress = order?.attributes?.addresseDeLivraison?.data;
  const size = packings?.reduce((acc, packing) => {
    console.log(packing?.attributes?.model?.data?.attributes);
    return packing?.attributes?.model?.data?.attributes?.productType === 1
      ? 1 + acc
      : acc;
  }, 0);
  const weight = packings?.reduce(
    (acc, packing) =>
      packing?.attributes?.model?.data?.attributes?.caracteristique?.data
        ?.attributes?.weight ?? 0 + acc,
    0,
  );

  let deliveryStatusLabel = t("To be Validated by the transporter");
  if (delivery?.attributes?.deliveryStatus === "RECUP") {
    deliveryStatusLabel = t("Retrieved by the transporter");
  } else if (
    ["DELIVERED", "INVOICE"]?.includes(delivery?.attributes?.deliveryStatus)
  ) {
    deliveryStatusLabel = t("Delivered");
  } else if (delivery?.attributes?.deliveryStatus === "DELIVERY") {
    deliveryStatusLabel = t("Out for delivery");
  }

  return (
    <div className="d-flex flex-column gap-4 text-dark position-relative text-break">
      <div className="row">
        <div className="col-3">
          {t("Order")} : <strong>{order?.attributes?.number}</strong>
        </div>
        <div className="col-3">
          {t("Partner")} : <strong>{reseller?.attributes?.name}</strong>
        </div>
      </div>
      <div className="row">
        <div className="col-3 d-flex flex-column gap-2">
          {t("Pickup Date")}
          <strong className=" p-2 br5 border-1 border-lightGrey">
            {delivery?.attributes?.recupDate ? (
              <p className="mb-0">
                {moment(delivery?.attributes?.recupDate).format("DD/MM/YYYY")}
              </p>
            ) : (
              "-"
            )}
          </strong>
        </div>
        <div className="col-3 d-flex flex-column gap-2">
          {t("Depot Referent")}
          <p className="p-2 br5 border-1 border-lightGrey">
            <strong>{storekeeper?.attributes?.name ?? "-"}</strong>
            <br />
            {storekeeper?.attributes?.user?.data?.attributes?.phoneNumber && (
              <p className="mb-0">
                T :{" "}
                <strong>
                  {storekeeper?.attributes?.user?.data?.attributes?.phoneNumber}
                </strong>
              </p>
            )}
            {storekeeper?.attributes?.user?.data?.attributes?.email && (
              <p className="mb-0">
                M :{" "}
                <strong>
                  {storekeeper?.attributes?.user?.data?.attributes?.email}
                </strong>
              </p>
            )}
          </p>
        </div>
        <div className="col-6 d-flex flex-column gap-2">
          {t("Depot Address")}
          <p className="sBold p-2 br5 border-1 border-lightGrey">
            {depot?.attributes?.name}
            <br />
            {depotAddress?.attributes?.street}
            <br />
            {depotAddress?.attributes?.city?.data?.attributes?.name}
            <br />
            {depotAddress?.attributes?.country?.data?.attributes?.name}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-3 d-flex flex-column gap-2">
          {t("Requested Delivery Date")}
          <p className="mb-0 p-2 br5 border-1 border-lightGrey">
            {delivery?.attributes?.date ? (
              <strong>
                {moment(delivery?.attributes?.date).format("DD/MM/YYYY")}
              </strong>
            ) : (
              "-"
            )}
          </p>
        </div>
        <div className="col-3 d-flex flex-column gap-2">
          {t("Partner")}
          <p className="p-2 br5 border-1 border-lightGrey">
            <strong>{reseller?.attributes?.name ?? "-"}</strong>
            <br />
            {reseller?.attributes?.phoneNumber && (
              <p className="mb-0">
                T : <strong>{reseller?.attributes?.phoneNumber}</strong>
              </p>
            )}
            {reseller?.attributes?.email && (
              <p className="mb-0">
                M : <strong>{reseller?.attributes?.email}</strong>
              </p>
            )}
          </p>
        </div>
        <div className="col-6 d-flex flex-column gap-2">
          {t("Delivery Address")}
          <p className="sBold p-2 br5 border-1 border-lightGrey">
            {reseller && (
              <>
                {reseller?.attributes?.name}
                <br />
              </>
            )}
            {deliveryAddress?.attributes?.street}
            <br />
            {deliveryAddress?.attributes?.city?.data?.attributes?.name}
            <br />
            {deliveryAddress?.attributes?.country?.data?.attributes?.name}
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-4 d-flex flex-column gap-2">
          {t("Delivery Type")}
          <p className="sBold p-2 br5 border-1 border-lightGrey">
            {order?.attributes?.delivery_type?.data?.attributes?.name ?? "-"}
          </p>
        </div>
        <div className="col-4 d-flex flex-column gap-2">
          {t("No. of pallets/Cartons")}
          <p className="sBold p-2 br5 border-1 border-lightGrey">
            {size ?? "-"}
          </p>
        </div>
        <div className="col-4 d-flex flex-column gap-2">
          {t("Total Weight")}
          <p className="sBold p-2 br5 border-1 border-lightGrey">
            {weight || 0} kg
          </p>
        </div>
      </div>
      <div className="row">
        <div className="col-3 d-flex flex-column">
          <p className="mb-2">{t("Depot Status")}</p>
          <div
            className="py-1 px-1 br8 text-white sBold w-100 text-center w-100"
            style={{
              backgroundColor: statusColors[delivery?.attributes?.status],
            }}
          >
            {t(`${statusLabel[delivery?.attributes?.status]}`)} {}
          </div>
        </div>
        <div className="col d-flex flex-column">
          <p className="mb-2">{t("Delivery Status")}</p>
          <div
            className="py-1 px-3 br8 text-white medium fit-content text-center text-nowrap text-uppercase"
            style={{
              backgroundColor: [
                "DELIVERED",
                "RECUP",
                "DELIVERY",
                "INVOICE",
              ].includes(delivery?.attributes?.deliveryStatus)
                ? statusColors[delivery?.attributes?.deliveryStatus]
                : "#c9762e",
            }}
          >
            {deliveryStatusLabel}
          </div>
        </div>
      </div>
    </div>
  );
};

export default DepartureInfos;
